import type { Directive } from "vue";

// v-reveal: fades/slides an element in when it scrolls into view.
// Optional value is a stagger delay in ms, e.g. v-reveal="index * 80".
// Styles live in style.css (.reveal / .is-visible).

let observer: IntersectionObserver | null = null;

function show(el: HTMLElement) {
  el.classList.add("is-visible");
  // Drop the stagger once the entrance finishes so hover effects aren't delayed
  el.addEventListener(
    "transitionend",
    () => {
      el.style.transitionDelay = "";
    },
    { once: true }
  );
}

function getObserver() {
  if (!observer) {
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            show(entry.target as HTMLElement);
            observer?.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -40px 0px" }
    );
  }
  return observer;
}

export const reveal: Directive<HTMLElement, number | undefined> = {
  mounted(el, binding) {
    el.classList.add("reveal");
    if (binding.value) el.style.transitionDelay = `${binding.value}ms`;

    if (!("IntersectionObserver" in window)) {
      show(el);
      return;
    }
    getObserver().observe(el);
  },
  unmounted(el) {
    observer?.unobserve(el);
  },
};
